// extracted by mini-css-extract-plugin
export default {"sectionTitle":"OrderInvoices_sectionTitle__2MmqV","invoiceLine":"OrderInvoices_invoiceLine__AUiKd"};